import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'orange' | 'white';
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  variant = 'orange',
  href = '#offer'
}: CTAButtonProps) {
  const colors = variant === 'orange' ? 'bg-brand-orange text-white hover:bg-[#dd6d20] focus-visible:ring-brand-orange' : 'bg-white text-brand-blue hover:bg-brand-main focus-visible:ring-white';
  return <a href={href} className={`cta-attention inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-sm font-extrabold tracking-wide shadow-md transition duration-300 hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 md:text-base ${colors} ${className}`} data-id="element-45" data-mp="2p0t3bhd5olkm">
      {children}
      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-46" data-mp="3cqdpe94lvyy4" />
    </a>;
}